export const mask_number = (phone) => {
  let first3 = phone.substring(0, 3);
  let last3 = phone.substring(phone.length - 3);
  let mask = phone.substring(3, phone.length - 3).replace(/\d/g, "*");
  return first3 + mask + last3;
};
